// extracted by mini-css-extract-plugin
export var label = "_al-1";
export var reminder = "_al-0";